import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { CustomToolForm } from './CustomToolForm';

import type { CreateCustomToolDto, UpdateCustomToolDto } from '@repo/shared-types';

interface CustomToolModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit?: (values: CreateCustomToolDto | UpdateCustomToolDto) => void;
  errors?: Array<{ field: string; message: string }>;
  isLoading?: boolean;
  initialValues?: CreateCustomToolDto;
  mode?: 'create' | 'edit';
}

export const CustomToolModal = ({
  open,
  onOpenChange,
  onSubmit,
  errors,
  isLoading,
  initialValues,
  mode = 'create',
}: CustomToolModalProps) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/60" />
        <Dialog.Content className="bg-background fixed top-1/2 left-1/2 z-50 w-full max-w-4xl -translate-x-1/2 -translate-y-1/2 rounded-lg p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <Dialog.Title className="text-lg font-semibold">
              {mode === 'edit' ? 'Edit custom tool' : 'Create custom tool'}
            </Dialog.Title>
            <Dialog.Close asChild>
              <Button variant="ghost" size="icon" disabled={isLoading}>
                <X className="h-4 w-4" />
              </Button>
            </Dialog.Close>
          </div>
          <div className="mt-4 max-h-[75vh] overflow-y-auto pe-6">
            <CustomToolForm
              initialValues={initialValues}
              onSubmit={onSubmit}
              errors={errors}
              isLoading={isLoading}
              submitLabel={mode === 'edit' ? 'Update tool' : 'Create tool'}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
